import Landing from '../components/Landing';

const Discover = () =>{
    
    let pageInfo = {
        name: "discover",
        title:"sakura.title",
        headline: "sakura.headline",
        text:"sakura.text",
        nextText:"sakura.nextNav",
        nextUrl:"explore",
        prevText:"sakura.prevNav",
        prevUrl:"experience",
        comingSoonText:"sakura.comingSoonText",
        buttonText:"sakura.ctaText",
        buttonUrl:"origami"
    }

    return(
        <Landing pageInfo={pageInfo} />
    )
}

export default Discover;